import "./Programs.module.css";
import Header from "@/reusable_sections/Header";
import ComprehensiveCareSupport from "./sections/ComprehensiveCareSupport";
import CommonQuestions from "./sections/CommonQuestions";
import Footer from "@/reusable_sections/Footer";
export default function ProgramsPage() {
  return <div>
      <Header />
      <ComprehensiveCareSupport />
      <CommonQuestions />
      <Footer />
    </div>;
}